<!-- Modern Holding Button -->
<button type="button" class="btn btn-light btn-light-walai border rounded-pill py-2" data-bs-toggle="modal"
  data-bs-target="#HoldingModal">
  <i class="bi bi-journal-text me-2"></i>
  <span>{{'Holding' | translate}}</span>
</button>

<!-- Modern Holding Modal -->
<div class="modal fade" id="HoldingModal" tabindex="-1" aria-labelledby="holdingModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-fullscreen-md-down modal-xl modal-dialog-scrollable">
    <div class="modal-content border-0 shadow-lg">

      <!-- Modal Header -->
      <div class="modal-header bg-light border-0 py-3">
        <div class="d-flex align-items-center gap-3">
          <div class="marc-icon-wrapper">
            <i class="bi bi-journal-text text-primary fs-4"></i>
          </div>
          <div>
            <h5 class="modal-title fw-bold mb-0" id="holdingModalLabel">{{'Holding' | translate}}</h5>
            <p class="text-muted small mb-0">{{ 'SerialHoldingsInformation' | translate }}</p>
          </div>
        </div>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body p-0">
        <div class="holding-container">

          <!-- Holdings Loop -->
          <ng-container *ngFor="let h of holdings; let holdingIndex = index">
            <div class="holding-section">

              <!-- Location Header -->
              <div class="location-header">
                <div class="d-flex align-items-center gap-3">
                  <i class="bi bi-geo-alt-fill text-primary"></i>
                  <h5 class="mb-0 text-primary fw-bold">{{ h.Location }}</h5>
                </div>
              </div>

              <!-- Holding Data List -->
              <div class="holding-data-list">
                <div *ngFor="let data of h.HoldingData; let i = index" class="holding-data-item"
                  [class.holding-data-even]="i % 2 === 0">

                  <div class="d-flex align-items-start gap-3">
                    <div class="holding-number">
                      <span class="badge bg-light text-secondary rounded-pill px-3 py-2">{{ i + 1 }}</span>
                    </div>
                    <div class="holding-content">
                      <div class="holding-subfield">{{ data.Subfield }}</div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </ng-container>

          <!-- Empty State -->
          <div *ngIf="!holdings || holdings.length === 0" class="holding-empty-state">
            <i class="bi bi-inbox fs-1 text-muted mb-3"></i>
            <p class="text-muted">{{ 'NoHoldingInformationAvailable' | translate }}</p>
          </div>

        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer bg-light border-0">
        <button type="button" class="btn btn-outline-secondary rounded-pill px-4" data-bs-dismiss="modal">
          <i class="bi bi-x-circle me-2"></i>
          {{ 'Close' | translate }}
        </button>
        <button type="button" class="btn btn-primary rounded-pill px-4" (click)="copyToClipboard()">
          <i class="bi bi-clipboard me-2"></i>
          {{ 'CopyHoldings' | translate }}
        </button>
      </div>

    </div>
  </div>
</div>